//= =====================
// Auth Action Types
//= =====================
export const AUTH_USER = "AUTH_USER";
export const UNAUTH_USER = "UNAUTH_USER";

//= =====================
// Dashboard Action Types
//= =====================
export const FETCH_DASHBOARD_STATS_REQUEST = "FETCH_DASHBOARD_STATS_REQUEST";
export const FETCH_DASHBOARD_STATS_SUCCESS = "FETCH_DASHBOARD_STATS_SUCCESS";
export const FETCH_DASHBOARD_STATS_FAILURE = "FETCH_DASHBOARD_STATS_FAILURE";
export const FETCH_APP_STORE_RATINGS_REQUEST = "FETCH_APP_STORE_RATINGS_REQUEST";
export const FETCH_APP_STORE_RATINGS_SUCCESS = "FETCH_APP_STORE_RATINGS_SUCCESS";
export const FETCH_APP_STORE_RATINGS_FAILURE = "FETCH_APP_STORE_RATINGS_FAILURE";

//= =====================
// Error Types
//= =====================
export const API_ERROR = "API_ERROR";
export const AUTH_ERROR = "AUTH_ERROR";

//= =====================
// Category Types
//= =====================
export const FETCH_ALL_CATEGORIES = "FETCH_ALL_CATEGORIES";
export const FETCH_ONE_CATEGORY = "FETCH_ONE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const CLEAR_ALL_SUB_CATEGORIES = "CLEAR_ALL_SUB_CATEGORIES";

//= =====================
// Subcategory Types
//= =====================
export const FETCH_ALL_SUBCATEGORIES_START = "FETCH_ALL_SUBCATEGORIES_START";
export const FETCH_ALL_SUBCATEGORIES = "FETCH_ALL_SUBCATEGORIES";
export const FETCH_ONE_SUBCATEGORY = "FETCH_ONE_SUBCATEGORY";
export const FETCH_ONE_SUBCATEGORY_START = "FETCH_ONE_SUBCATEGORY_START";

//= =====================
// Subcategory Types
//= =====================
export const FETCH_ALL_CHALLENGES = "FETCH_ALL_CHALLENGES";
export const FETCH_ONE_CHALLENGE = "FETCH_ONE_CHALLENGE";
//= =====================
// Series Types
//= =====================

export const FETCH_ALL_SERIES_START = "FETCH_ALL_SERIES_START";
export const FETCH_ALL_SERIES = "FETCH_ALL_SERIES";
//= =====================
// Reflection Types
//= =====================
export const FETCH_ALL_DAILY_REFLECTIONS = "FETCH_ALL_DAILY_REFLECTIONS";
export const FETCH_ALL_DAILY_REFLECTIONS_SUCCESS = "FETCH_ALL_DAILY_REFLECTIONS_SUCCESS";
export const FETCH_ALL_DAILY_REFLECTIONS_ERROR = "FETCH_ALL_DAILY_REFLECTIONS_ERROR";
export const SAVE_DAILY_REFLECTION = "SAVE_DAILY_REFLECTION";
export const SAVE_DAILY_REFLECTION_SUCCESS = "SAVE_DAILY_REFLECTION_SUCCESS";
export const SAVE_DAILY_REFLECTION_ERROR = "SAVE_DAILY_REFLECTION_ERROR";
export const DELETE_DAILY_REFLECTION = "DELETE_DAILY_REFLECTION";
export const DELETE_DAILY_REFLECTION_SUCCESS = "DELETE_DAILY_REFLECTION_SUCCESS";
export const DELETE_DAILY_REFLECTION_ERROR = "DELETE_DAILY_REFLECTION_ERROR";
export const FETCH_ONE_DAILY_REFLECTION = "FETCH_ONE_DAILY_REFLECTION";
export const FETCH_ONE_DAILY_REFLECTION_SUCCESS = "FETCH_ONE_DAILY_REFLECTION_SUCCESS";
export const FETCH_ONE_DAILY_REFLECTION_ERROR = "FETCH_ONE_DAILY_REFLECTION_ERROR";
export const CLOSE_DAILY_REFLECTION_FORM = "CLOSE_DAILY_REFLECTION_FORM";
//= =====================
// Session Types
//= =====================
export const FETCH_ALL_SESSIONS = "FETCH_ALL_SESSIONS";
export const FETCH_ALL_SESSIONS_START = "FETCH_ALL_SESSIONS_START";
// Paginated endpoint (CMS API GET /sessions?page=…&per_page=…&…) — one row
// per session with parents aggregated into arrays. Used by SessionsTableV2.
export const FETCH_SESSIONS_PAGE_START = "FETCH_SESSIONS_PAGE_START";
export const FETCH_SESSIONS_PAGE_SUCCESS = "FETCH_SESSIONS_PAGE_SUCCESS";
export const FETCH_SESSIONS_PAGE_FAILURE = "FETCH_SESSIONS_PAGE_FAILURE";
// Grouped view — one accordion section per parent_type. Each section
// makes its own paginated request with `parent_type=…` so the response
// is just the sessions in that bucket. Used by SessionsTableV2 grouped view.
export const FETCH_SESSIONS_GROUP_START = "FETCH_SESSIONS_GROUP_START";
export const FETCH_SESSIONS_GROUP_SUCCESS = "FETCH_SESSIONS_GROUP_SUCCESS";
export const FETCH_SESSIONS_GROUP_FAILURE = "FETCH_SESSIONS_GROUP_FAILURE";
//= =====================
// Quick Taps Types
//= =====================
export const FETCH_ALL_QUICK_TAPS_START = "FETCH_ALL_QUICK_TAPS_START";
export const FETCH_ALL_QUICK_TAPS = "FETCH_ALL_QUICK_TAPS";
// Paginated endpoint (GET /quick-tap-sessions?page=…&per_page=…&…) —
// one row per quick tap with parent / author nested objects. Mirrors
// the FETCH_SESSIONS_PAGE_* triad. Used by QuickTapsTableV2.
export const FETCH_QUICK_TAPS_PAGE_START = "FETCH_QUICK_TAPS_PAGE_START";
export const FETCH_QUICK_TAPS_PAGE_SUCCESS = "FETCH_QUICK_TAPS_PAGE_SUCCESS";
export const FETCH_QUICK_TAPS_PAGE_FAILURE = "FETCH_QUICK_TAPS_PAGE_FAILURE";
//= =====================
// Session Recommended/Popular List Types
//= =====================
export const FETCH_RECOMMENDED_LIST_START = "FETCH_RECOMMENDED_LIST_START";
export const FETCH_RECOMMENDED_LIST = "FETCH_RECOMMENDED_LIST";
export const FETCH_RECOMMENDED_LIST_ERROR = "FETCH_RECOMMENDED_LIST_ERROR";
export const FETCH_POPULAR_LIST_START = "FETCH_POPULAR_LIST_START";
export const FETCH_POPULAR_LIST = "FETCH_POPULAR_LIST";
export const FETCH_POPULAR_LIST_ERROR = "FETCH_POPULAR_LIST_ERROR";
//= =====================
// Session Tags
//= =====================
export const FETCH_TAGS = "FETCH_TAGS";
//= =====================
// Tapping Points Types
//= =====================
export const FETCH_ALL_TAPPING_POINTS = "FETCH_ALL_TAPPING_POINTS";
export const CLEAR_TAPPING_POINTS = "CLEAR_TAPPING_POINTS";

//= =====================
// Author Types
//= =====================
export const FETCH_AUTHORS = "FETCH_AUTHORS";
export const FETCH_ONE_AUTHOR = "FETCH_ONE_AUTHOR";
export const CLEAR_AUTHORS = "CLEAR_AUTHORS";
export const FETCH_AUTHORS_SESSIONS = "FETCH_AUTHORS_SESSIONS";
export const FETCH_AUTHORS_PROGRAMS = "FETCH_AUTHORS_PROGRAMS";
export const UPLOAD_AUTHORS_IMAGE = "UPLOAD_AUTHORS_IMAGE";

//= =====================
// Global Action Types
//= =====================
export const FETCH_GENERAL_INFO = "FETCH_GENERAL_INFO";
export const UPDATE_GENERAL_INFO = "UPDATE_GENERAL_INFO";
export const DELETE_GENERAL_INFO = "DELETE_GENERAL_INFO";
export const CREATE_GENERAL_INFO = "CREATE_GENERAL_INFO";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const CLEAR_SUCCESS = "CLEAR_SUCCESS";
export const CLEAR_HIGHLIGHT = "CLEAR_HIGHLIGHT";

//= =====================
// Quote Actions
//= =====================
export const UPLOAD_IMAGE = "UPLOAD_IMAGE";
export const UPLOAD_IMAGE_TARGET = "UPLOAD_IMAGE_TARGET";
export const UPLOAD_AUDIO = "UPLOAD_AUDIO";
export const UPLOAD_VIDEO = "UPLOAD_VIDEO";
export const UPLOAD_MUX_VIDEO = "UPLOAD_MUX_VIDEO";
export const CLEAR_MEDIA = "CLEAR_MEDIA";

//= =====================
// Quote Actions
//= =====================
export const FETCH_ALL_QUOTES = "FETCH_ALL_QUOTES";
export const FETCH_ONE_QUOTE = "FETCH_ONE_QUOTE";

//= =====================
// Tag Actions
//= =====================
export const FETCH_ALL_TAGS = "FETCH_ALL_TAGS";

//= =====================
// Feedbacks Actions
//= =====================
export const FETCH_FEEDBACKS = "FETCH_FEEDBACKS";

//= =====================
// Requests Actions
//= =====================
export const FETCH_REQUESTS = "FETCH_REQUESTS";

//= =====================
// Promo Banner Actions
//= =====================
export const FETCH_ALL_PROMO_BANNERS = "FETCH_ALL_PROMO_BANNERS";

//= =====================
// Promo Data Actions
//= =====================
export const FETCH_ALL_PROMO_DATA = "FETCH_ALL_PROMO_DATA";
export const FETCH_ALL_GENERAL_DATA = "FETCH_ALL_GENERAL_DATA";

//= =====================
// Background Music Actions
//= =====================
export const FETCH_ALL_BACKGROUND_MUSICS = "FETCH_ALL_BACKGROUND_MUSICS";

//= =====================
// Player Asset Actions (Avatars / Backgrounds / App Music)
//= =====================
export const FETCH_PLAYER_ASSETS = "FETCH_PLAYER_ASSETS";
export const FETCH_PLAYER_ASSETS_START = "FETCH_PLAYER_ASSETS_START";
export const FETCH_PLAYER_ASSETS_FAILED = "FETCH_PLAYER_ASSETS_FAILED";

//= =====================
// Onboarding Data Actions
//= =====================

export const FETCH_ALL_ONBOARDING_DATA = "FETCH_ALL_ONBOARDING_DATA";

//= =====================
// Search Actions
//= =====================

export const FETCH_ALL_TOP_SEARCH = "FETCH_ALL_TOP_SEARCH";
export const FETCH_SUGGESTED_SEARCH_OPTIONS = "FETCH_SUGGESTED_SEARCH_OPTIONS";
export const FETCH_SUGGESTED_SEARCH = "FETCH_SUGGESTED_SEARCH";
export const DELETE_TOP_SEARCH = "DELETE_TOP_SEARCH";
export const DELETE_SUGGESTED_SEARCH = "DELETE_SUGGESTED_SEARCH";
export const FETCH_SEARCH_DEEPLINKS = "FETCH_SEARCH_DEEPLINKS";

//= ============================
// CANCELLATION REASONS Actions
//= ============================

export const UPDATE_CANCELLATION_REASON = "UPDATE_CANCELLATION_REASON";
export const FETCH_CANCELLATION_REASONS = "FETCH_CANCELLATION_REASONS";
export const DELETE_CANCELLATION_REASON = "DELETE_CANCELLATION_REASON";
export const FETCH_USER_CANCELLATION_REPORT = "FETCH_USER_CANCELLATION_REPORT";
export const FETCH_CANCELLATION_DISTRIBUTION_PENDING = "FETCH_CANCELLATION_DISTRIBUTION_PENDING";
export const FETCH_CANCELLATION_DISTRIBUTION_SUCCESS = "FETCH_CANCELLATION_DISTRIBUTION_SUCCESS";
export const FETCH_CANCELLATION_DISTRIBUTION_ERROR = "FETCH_CANCELLATION_DISTRIBUTION_ERROR";
export const FETCH_CANCELLATION_OVER_TIME_PENDING = "FETCH_CANCELLATION_OVER_TIME_PENDING";
export const FETCH_CANCELLATION_OVER_TIME_SUCCESS = "FETCH_CANCELLATION_OVER_TIME_SUCCESS";
export const FETCH_CANCELLATION_OVER_TIME_ERROR = "FETCH_CANCELLATION_OVER_TIME_ERROR";

// USER STREAK
export const FETCH_USER_STREAK = "FETCH_USER_STREAK";
export const RESTORE_USER_STREAK = "RESTORE_USER_STREAK";
export const FETCH_USER_STREAK_ERROR = "FETCH_USER_STREAK_ERROR";
export const CLEAR_USER_STREAK = "CLEAR_USER_STREAK";

// DECKS
export const FETCH_CARD_DECKS = "FETCH_CARD_DECKS";
export const FETCH_CARD_DECKS_SUCCESS = "FETCH_CARD_DECKS_SUCCESS";
export const FETCH_CARD_DECKS_ERROR = "FETCH_CARD_DECKS_ERROR";
export const SAVE_CARD_DECKS = "SAVE_CARD_DECKS";
export const SAVE_CARD_DECKS_SUCCESS = "SAVE_CARD_DECKS_SUCCESS";
export const SAVE_CARD_DECKS_ERROR = "SAVE_CARD_DECKS_ERROR";
export const FETCH_ONE_CARD_DECK = "FETCH_ONE_CARD_DECK";
export const FETCH_ONE_CARD_DECK_SUCCESS = "FETCH_ONE_CARD_DECK_SUCCESS";
export const FETCH_ONE_CARD_DECK_ERROR = "FETCH_ONE_CARD_DECK_ERROR";
export const CLOSE_EDIT_CARD_DECK = "CLOSE_EDIT_CARD_DECK";
export const CLOSE_EDIT_CARD_DECK_SUCCESS = "CLOSE_EDIT_CARD_DECK_SUCCESS";
export const DELETE_CARD_DECK = "DELETE_CARD_DECK";
export const DELETE_CARD_DECK_SUCCESS = "DELETE_CARD_DECK_SUCCESS";
export const DELETE_CARD_DECK_ERROR = "DELETE_CARD_DECK_ERROR";
export const SORT_CARD_DECKS = "SORT_CARD_DECKS";
export const SORT_CARD_DECKS_SUCCESS = "SORT_CARD_DECKS_SUCCESS";
export const SORT_CARD_DECKS_ERROR = "SORT_CARD_DECKS_ERROR";

// CARDS
export const FETCH_DECK_CARDS = "FETCH_DECK_CARDS";
export const FETCH_DECK_CARDS_SUCCESS = "FETCH_DECK_CARDS_SUCCESS";
export const FETCH_DECK_CARDS_ERROR = "FETCH_DECK_CARDS_ERROR";
export const SAVE_DECK_CARD = "SAVE_DECK_CARD";
export const SAVE_DECK_CARD_SUCCESS = "SAVE_DECK_CARD_SUCCESS";
export const SAVE_DECK_CARD_ERROR = "SAVE_DECK_CARD_ERROR";
export const FETCH_UNPARENTED_CARDS = "FETCH_UNPARENTED_CARDS";
export const FETCH_UNPARENTED_CARDS_SUCCESS = "FETCH_UNPARENTED_CARDS_SUCCESS";
export const FETCH_UNPARENTED_CARDS_ERROR = "FETCH_UNPARENTED_CARDS_ERROR";
export const FETCH_ONE_DECK_CARD = "FETCH_ONE_DECK_CARD";
export const FETCH_ONE_DECK_CARD_SUCCESS = "FETCH_ONE_DECK_CARD_SUCCESS";
export const FETCH_ONE_DECK_CARD_ERROR = "FETCH_ONE_DECK_CARD_ERROR";
export const CLOSE_EDIT_DECK_CARD = "CLOSE_EDIT_DECK_CARD";
export const CLOSE_EDIT_DECK_CARD_SUCCESS = "CLOSE_EDIT_DECK_CARD_SUCCESS";
export const REMOVE_CARD_FROM_DECK = "REMOVE_CARD_FROM_DECK";
export const REMOVE_CARD_FROM_DECK_SUCCESS = "REMOVE_CARD_FROM_DECK_SUCCESS";
export const REMOVE_CARD_FROM_DECK_ERROR = "REMOVE_CARD_FROM_DECK_ERROR";
export const ADD_CARD_TO_DECK = "ADD_CARD_TO_DECK";
export const ADD_CARD_TO_DECK_SUCCESS = "ADD_CARD_TO_DECK_SUCCESS";
export const ADD_CARD_TO_DECK_ERROR = "ADD_CARD_TO_DECK_ERROR";
export const SORT_DECK_CARDS = "SORT_DECK_CARDS";
export const SORT_DECK_CARDS_SUCCESS = "SORT_DECK_CARDS_SUCCESS";
export const SORT_DECK_CARDS_ERROR = "SORT_DECK_CARDS_ERROR";

//MEDIA RESOURCES
export const FETCH_MEDIA_RESOURCES = "FETCH_MEDIA_RESOURCES";
export const FETCH_MEDIA_RESOURCES_SUCCESS = "FETCH_MEDIA_RESOURCES_SUCCESS";
export const FETCH_MEDIA_RESOURCES_ERROR = "FETCH_MEDIA_RESOURCES_ERROR";
export const SAVE_MEDIA_RESOURCE = "SAVE_MEDIA_RESOURCE";
export const SAVE_MEDIA_RESOURCE_SUCCESS = "SAVE_MEDIA_RESOURCE_SUCCESS";
export const SAVE_MEDIA_RESOURCE_ERROR = "SAVE_MEDIA_RESOURCE_ERROR";
export const DELETE_MEDIA_RESOURCE = "DELETE_MEDIA_RESOURCE";
export const DELETE_MEDIA_RESOURCE_SUCCESS = "DELETE_MEDIA_RESOURCE_SUCCESS";
export const DELETE_MEDIA_RESOURCE_ERROR = "DELETE_MEDIA_RESOURCE_ERROR";
export const UPDATE_MEDIA_RESOURCE = "UPDATE_MEDIA_RESOURCE";
export const UPDATE_MEDIA_RESOURCE_SUCCESS = "UPDATE_MEDIA_RESOURCE_SUCCESS";
export const UPDATE_MEDIA_RESOURCE_ERROR = "UPDATE_MEDIA_RESOURCE_ERROR";

//ADMINS
export const FETCH_ALL_ADMINS = "FETCH_ALL_ADMINS";
export const FETCH_ALL_ADMINS_SUCCESS = "FETCH_ALL_ADMINS_SUCCESS";
export const FETCH_ALL_ADMINS_ERROR = "FETCH_ALL_ADMINS_ERROR";
export const SAVE_ADMIN = "SAVE_ADMIN";
export const SAVE_ADMIN_SUCCESS = "SAVE_ADMIN_SUCCESS";
export const SAVE_ADMIN_ERROR = "SAVE_ADMIN_ERROR";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_ADMIN_ERROR = "DELETE_ADMIN_ERROR";
export const FETCH_ONE_ADMIN = "FETCH_ONE_ADMIN";
export const FETCH_ONE_ADMIN_SUCCESS = "FETCH_ONE_ADMIN_SUCCESS";
export const FETCH_ONE_ADMIN_ERROR = "FETCH_ONE_ADMIN_ERROR";
export const RESET_PASSWORD_ADMIN = "RESET_PASSWORD_ADMIN";
export const RESET_PASSWORD_ADMIN_SUCCESS = "RESET_PASSWORD_ADMIN_SUCCESS";
export const RESET_PASSWORD_ADMIN_ERROR = "RESET_PASSWORD_ADMIN_ERROR";
export const UPDATE_PROFILE_ADMIN = "UPDATE_PROFILE_ADMIN";
export const UPDATE_PROFILE_ADMIN_SUCCESS = "UPDATE_PROFILE_ADMIN_SUCCESS";
export const UPDATE_PROFILE_ADMIN_ERROR = "UPDATE_PROFILE_ADMIN_ERROR";

//MARKETING INITIATIVES
export const FETCH_ALL_MARKETING_INITIATIVES = "FETCH_ALL_MARKETING_INITIATIVES";
export const FETCH_ALL_MARKETING_INITIATIVES_SUCCESS = "FETCH_ALL_MARKETING_INITIATIVES_SUCCESS";
export const FETCH_ALL_MARKETING_INITIATIVES_ERROR = "FETCH_ALL_MARKETING_INITIATIVES_ERROR";
export const SAVE_MARKETING_INITIATIVE = "SAVE_MARKETING_INITIATIVE";
export const SAVE_MARKETING_INITIATIVE_SUCCESS = "SAVE_MARKETING_INITIATIVE_SUCCESS";
export const SAVE_MARKETING_INITIATIVE_ERROR = "SAVE_MARKETING_INITIATIVE_ERROR";
export const DELETE_MARKETING_INITIATIVE = "DELETE_MARKETING_INITIATIVE";
export const DELETE_MARKETING_INITIATIVE_SUCCESS = "DELETE_MARKETING_INITIATIVE_SUCCESS";
export const DELETE_MARKETING_INITIATIVE_ERROR = "DELETE_MARKETING_INITIATIVE_ERROR";
export const ENABLE_DISABLE_MARKETING_INITIATIVE = "ENABLE_DISABLE_MARKETING_INITIATIVE";
export const ENABLE_DISABLE_MARKETING_INITIATIVE_SUCCESS = "ENABLE_DISABLE_MARKETING_INITIATIVE_SUCCESS";
export const ENABLE_DISABLE_MARKETING_INITIATIVE_ERROR = "ENABLE_DISABLE_MARKETING_INITIATIVE_ERROR";
export const FETCH_ONE_MARKETING_INITIATIVE = "FETCH_ONE_MARKETING_INITIATIVE";
export const FETCH_ONE_MARKETING_INITIATIVE_SUCCESS = "FETCH_ONE_MARKETING_INITIATIVE_SUCCESS";
export const FETCH_ONE_MARKETING_INITIATIVE_ERROR = "FETCH_ONE_MARKETING_INITIATIVE_ERROR";

// Role Management
export const FETCH_ALL_ROLES = "FETCH_ALL_ROLES";
export const FETCH_ALL_ROLES_SUCCESS = "FETCH_ALL_ROLES_SUCCESS";
export const FETCH_ALL_ROLES_ERROR = "FETCH_ALL_ROLES_ERROR";

export const FETCH_ONE_ROLE = "FETCH_ONE_ROLE";
export const FETCH_ONE_ROLE_SUCCESS = "FETCH_ONE_ROLE_SUCCESS";
export const FETCH_ONE_ROLE_ERROR = "FETCH_ONE_ROLE_ERROR";

export const SAVE_ROLE = "SAVE_ROLE";
export const SAVE_ROLE_SUCCESS = "SAVE_ROLE_SUCCESS";
export const SAVE_ROLE_ERROR = "SAVE_ROLE_ERROR";

export const DELETE_ROLE = "DELETE_ROLE";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_ERROR = "DELETE_ROLE_ERROR";

// Attribution Options
export const FETCH_ATTRIBUTION_OPTIONS = "FETCH_ATTRIBUTION_OPTIONS";
export const FETCH_ATTRIBUTION_OPTIONS_START = "FETCH_ATTRIBUTION_OPTIONS_START";
export const FETCH_ATTRIBUTION_OPTIONS_ERROR = "FETCH_ATTRIBUTION_OPTIONS_ERROR";
export const CREATE_ATTRIBUTION_OPTION = "CREATE_ATTRIBUTION_OPTION";
export const UPDATE_ATTRIBUTION_OPTION = "UPDATE_ATTRIBUTION_OPTION";
export const DELETE_ATTRIBUTION_OPTION = "DELETE_ATTRIBUTION_OPTION";

// Permission Management
export const FETCH_ALL_PERMISSIONS = "FETCH_ALL_PERMISSIONS";
export const FETCH_ALL_PERMISSIONS_SUCCESS = "FETCH_ALL_PERMISSIONS_SUCCESS";
export const FETCH_ALL_PERMISSIONS_ERROR = "FETCH_ALL_PERMISSIONS_ERROR";

export const FETCH_ONE_PERMISSION = "FETCH_ONE_PERMISSION";
export const FETCH_ONE_PERMISSION_SUCCESS = "FETCH_ONE_PERMISSION_SUCCESS";
export const FETCH_ONE_PERMISSION_ERROR = "FETCH_ONE_PERMISSION_ERROR";

export const SAVE_PERMISSION = "SAVE_PERMISSION";
export const SAVE_PERMISSION_SUCCESS = "SAVE_PERMISSION_SUCCESS";
export const SAVE_PERMISSION_ERROR = "SAVE_PERMISSION_ERROR";

export const DELETE_PERMISSION = "DELETE_PERMISSION";
export const DELETE_PERMISSION_SUCCESS = "DELETE_PERMISSION_SUCCESS";
export const DELETE_PERMISSION_ERROR = "DELETE_PERMISSION_ERROR";

//= =====================
// Captions Action Types
//= =====================
export const SET_CAPTIONS_LOADING = "SET_CAPTIONS_LOADING";
export const FETCH_CAPTIONS_REVIEW_QUEUE = "FETCH_CAPTIONS_REVIEW_QUEUE";
export const FETCH_SESSION_CAPTIONS = "FETCH_SESSION_CAPTIONS";
export const UPDATE_SESSION_CAPTION = "UPDATE_SESSION_CAPTION";
export const REMOVE_SESSION_CAPTION = "REMOVE_SESSION_CAPTION";
export const CLEAR_CAPTIONS = "CLEAR_CAPTIONS";

export const FETCH_CAPTION_VOCABULARY = "FETCH_CAPTION_VOCABULARY";
export const UPSERT_CAPTION_VOCABULARY_TERM = "UPSERT_CAPTION_VOCABULARY_TERM";
export const REMOVE_CAPTION_VOCABULARY_TERM = "REMOVE_CAPTION_VOCABULARY_TERM";

export const FETCH_AUTHOR_CAPTION_ALIASES = "FETCH_AUTHOR_CAPTION_ALIASES";
export const UPSERT_AUTHOR_CAPTION_ALIAS = "UPSERT_AUTHOR_CAPTION_ALIAS";
export const REMOVE_AUTHOR_CAPTION_ALIAS = "REMOVE_AUTHOR_CAPTION_ALIAS";

// Translation glossary + style/tone instructions, scoped per language
// — Phase 5. Both stored as plain arrays in state; the page filters
// in-memory by language.
export const FETCH_TRANSLATION_GLOSSARY = "FETCH_TRANSLATION_GLOSSARY";
export const UPSERT_TRANSLATION_GLOSSARY_TERM = "UPSERT_TRANSLATION_GLOSSARY_TERM";
export const REMOVE_TRANSLATION_GLOSSARY_TERM = "REMOVE_TRANSLATION_GLOSSARY_TERM";

export const FETCH_TRANSLATION_INSTRUCTIONS = "FETCH_TRANSLATION_INSTRUCTIONS";
export const UPSERT_TRANSLATION_INSTRUCTION = "UPSERT_TRANSLATION_INSTRUCTION";
export const REMOVE_TRANSLATION_INSTRUCTION = "REMOVE_TRANSLATION_INSTRUCTION";

//= =====================
// Experiments Types
//= =====================
export const FETCH_ALL_EXPERIMENTS = "FETCH_ALL_EXPERIMENTS";
export const FETCH_EXPERIMENT_SUMMARY = "FETCH_EXPERIMENT_SUMMARY";

// Goal Content Types
//= =====================
export const FETCH_ALL_GOAL_CONTENT = "FETCH_ALL_GOAL_CONTENT";
export const FETCH_FEATURE_FLAGS = "FETCH_FEATURE_FLAGS";
export const UPDATE_FEATURE_FLAG = "UPDATE_FEATURE_FLAG";
export const FETCH_TOPIC_SESSION_LIST_START = "FETCH_TOPIC_SESSION_LIST_START";
export const FETCH_TOPIC_SESSION_LIST = "FETCH_TOPIC_SESSION_LIST";
export const FETCH_TOPIC_SESSION_LIST_ERROR = "FETCH_TOPIC_SESSION_LIST_ERROR";
